import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DocumentsTable } from '@/components/shared/DocumentsTable';
import { ownDocumentsQueryOptions } from '@/hooks/useDocumentsQuery';
import { queryClient } from '@/lib/utils/queryClient';
import { useSessionStore } from '@/store/sessionStore';

const searchSchema = z.object({
  page: z.number().int().min(1).optional(),
  limit: z.number().int().min(10).max(500).optional(),
  sort: z.string().optional(),
  filters: z.record(z.array(z.string())).optional(),
  dialog: z.enum(['create-document']).optional(),
});

export const Route = createFileRoute(
  '/(client)/documents/(pages)/(list)/my-documents/',
)({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    limit: search.limit ?? 50,
    sort: search.sort,
  }),
  loader: ({ deps }) => {
    const companyId = useSessionStore.getState().user?.companyId ?? '';
    if (!companyId) return;
    return queryClient.ensureQueryData(
      ownDocumentsQueryOptions(companyId, {
        page: deps.page - 1,
        count: deps.limit,
        ...(deps.sort ? { sort: deps.sort } : {}),
      }),
    );
  },
  component: MyDocumentsTab,
});

function MyDocumentsTab() {
  const companyId = useSessionStore(s => s.user?.companyId ?? '');
  return (
    <DocumentsTable
      companyId={companyId}
      isOwnCompany={true}
      translationNamespace='documents'
    />
  );
}
